/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import hash from 'object-hash'
import Logger from '@/services/Logger'

function lookInCache ({ hash, useCache }) {
  if (!useCache) {
    return Promise.reject(new Error('not use cache'))
  } else {
    const esStore = require('./storage').esStore
    return esStore.getItem(hash).then(find => {
      if (find === null) {
        return Promise.reject(new Error('not found'))
      }
      return find
    })
  }
}

function saveInCache ({ hash, value, useCache }) {
  if (!useCache) {
    return Promise.reject(new Error('not possible to save in cache'))
  } else {
    const esStore = require('./storage').esStore
    return esStore.setItem(hash, value)
  }
}

function CacheHash (obj) {
  return hash(obj)
}

export function restWithCache ({
  query,
  body = {},
  restPromise
}) {
  return new Promise((resolve, reject) => {
    const startTime = Date.now()
    const hash = CacheHash({ ...{ query }, ...body })
    let valueReaded = false
    if (process.client) {
      lookInCache({ hash, useCache: true })
        .then(value => {
          if (!valueReaded) {
            Logger.debug(`readed from cache ${hash} time --> ${(Date.now() - startTime)}ms ${query}`)
            valueReaded = true
          }
          resolve(value)
        })
        .catch(() => {})
    }
    restPromise.then(value => {
      if (!valueReaded) {
        Logger.debug(`readed from CALL ${hash} time --> ${(Date.now() - startTime)}ms ${query} [${value.config.method}]`)
        valueReaded = true
      }
      resolve(value.data)
      if (process.client) {
        let useCache = true
        if (value.data & value.data.errors) {
          useCache = false
        }
        saveInCache({ hash, value: value.data, useCache: useCache })
      }
    })
      .catch(error => {
        reject(error)
      })
  })
}

export function clearAllCache () {
  const $storage = require('./storage')
  $storage.esStore.clear()
  $storage.userStore.clear()
  $storage.cartStore.clear()
}

export function clearEsCache () {
  const $storage = require('./storage')
  $storage.esStore.clear()
  Logger.debug('clear es cache')
}

// if (process.client) {
//   clearEsCache()
// }
